
// import React from 'react';
// import TravelCategory from './category/travel/TravelCategory';
// import Travelinternational from "./category/Travelinternational/Travelinternational"
// import "./Blog.css";
// import tornPaper from './frame.webp';  
// import bgImage from './BRAZIL.webp';       

// export default function Blog() {
//   return (
//     <div className="blog-page">
      
//       <div className="blog-banner">
        
//         <div 
//           className="banner-bg" 
//           style={{ backgroundImage: `url(${bgImage})` }}
//         ></div>
        
//         <img src={tornPaper} alt="Torn Paper" className="torn-paper" />

//          <div className="banner-text">
//           <h1>Unfold Hidden Destinations & Real Travel Tales</h1>
//           <p>Welcome to our official blog — your trusted source for insights...</p>
//         </div>

//       </div>

//       <TravelCategory />
//       <Travelinternational/>
     
//     </div>
//   );
// }


import React from 'react';
import styles from './Blog.module.css';
import TravelCategory from './category/travel/TravelCategory';
import Travelinternational from "./category/Travelinternational/Travelinternational";
import tornPaper from './frame.webp';  
import bgImage from './BRAZIL.webp';       

export default function Blog() {
  return (
    <div className={styles.blogPage}>
      <div className={styles.blogBanner}>
        <div 
          className={styles.bannerBg}
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>
        
        <img src={tornPaper} alt="Torn Paper" className={styles.tornPaper} />

        <div className={styles.bannerText}>
          <h1>Unfold Hidden Destinations & Real Travel Tales</h1>
          <p>Welcome to our official blog — your trusted source for insights...</p>
        </div>
      </div>

      <TravelCategory />
    <Travelinternational/>
    </div>
  );
}
